import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import rapidElearningRoutes from 'modules/trainingLibrary/RapidElearning/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const RapidElearningDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsRapidElearningDetails" */ 'modules/activityDetails/RapidElearningDetails/pages/RapidElearningDetails'
    )
)

const RapidElearningDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:rapidElearningId`} component={RapidElearningDetails} />
      <Redirect path='*' to={rapidElearningRoutes.root} />
    </Switch>
  </Suspense>
)

export default RapidElearningDetailsRouting
